import { useRef } from 'react'
import { Formik } from 'formik'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Textarea
} from '@cutilei/ui'
import blockUserValidator from 'validators/blockUserValidator'

const formStyle = {display: 'flex', flexDirection: 'column', gap: 16}

/*
  Pede o motivo antes de bloquear um usuário, sobre o AlertDialog do @cutilei/ui. Abre de dentro do
  MemberDetailsModal, por cima dele. O foco abre no campo do motivo; o Cancelar só
  fecha (antes ele também enviava o formulário e bloqueava o usuário quando o motivo estava
  preenchido).
*/
export default function BlockUserModal({
  visible,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const commentRef = useRef(null)

  return (
    <AlertDialog open={Boolean(visible)} onOpenChange={open => { if (!open) handleClose() }}>
      <AlertDialogContent
        onOpenAutoFocus={event => {
          event.preventDefault()
          commentRef.current?.focus()
        }}
      >
        <Formik
          validationSchema={blockUserValidator}
          initialValues={{comment: ''}}
          onSubmit={values => {
            handleConfirm(values.comment)
            handleClose()
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
            <form noValidate onSubmit={handleSubmit} style={formStyle}>
              <AlertDialogHeader>
                <AlertDialogTitle>Bloquear usuário</AlertDialogTitle>
                <AlertDialogDescription>
                  Se deseja bloquear este usuário, insira o motivo do bloqueio no campo abaixo.
                </AlertDialogDescription>
              </AlertDialogHeader>
              <Textarea
                ref={commentRef}
                label='Motivo'
                name='comment'
                rows={3}
                maxLength={512}
                counter
                value={values.comment}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.comment && errors.comment}
              />
              <AlertDialogFooter>
                <AlertDialogCancel>Cancelar</AlertDialogCancel>
                <AlertDialogAction
                  destructive
                  onClick={event => {
                    // Quem fecha é o onSubmit, depois da validação.
                    event.preventDefault()
                    handleSubmit()
                  }}
                >
                  Confirmar
                </AlertDialogAction>
              </AlertDialogFooter>
            </form>
          )}
        </Formik>
      </AlertDialogContent>
    </AlertDialog>
  )
}
